import Button from "Components/Button";
import FormInput from "Components/FormInput/FormInput";
import FormTextArea from "Components/FormTextArea";
import LoadingIcon from "Components/LoadingIcon";
import React, { Component } from "react";
import { Field, Form } from "react-final-form";
import styled from "styled-components";
import { mobileSize } from "Themes/Metrics";
import { FormError, FormSuccess } from "Themes/StyledComponents";

const FormContainer = styled.div`
  padding: 10px;
  display: flex;
`;

const LabelContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const FormInputContainer = styled.div`
  flex: 3;
`;

export const ButtonContainer = styled.div`
  width: 50%;
  float: right;
  padding: 10px;
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

const validate = values => {
  const errors = {};
  if (!values.projectName) {
    errors.projectName = "Required";
  }
  if (!values.projectDescription) {
    errors.projectDescription = "Required";
  }
  return errors;
};

class EditProjectDetailsForm extends Component {
  render() {
    const {
      handleSubmit,
      projectDescription,
      projectName,
      fetching,
      error,
      success
    } = this.props;
    return (
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={{
          projectName,
          projectDescription
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name={"projectName"}
              render={props => {
                return (
                  <FormContainer>
                    <LabelContainer>Project Name</LabelContainer>
                    <FormInputContainer>
                      <FormInput {...props} placeholder={projectName} />
                    </FormInputContainer>
                  </FormContainer>
                );
              }}
            />
            <Field
              name={"projectDescription"}
              render={props => {
                return (
                  <FormContainer>
                    <LabelContainer>Project Description</LabelContainer>
                    <FormInputContainer>
                      <FormTextArea
                        {...props}
                        placeholder={projectDescription}
                      />
                    </FormInputContainer>
                  </FormContainer>
                );
              }}
            />
            {error && <FormError>Oops...there was an error</FormError>}
            {success && <FormSuccess>Details updated!</FormSuccess>}
            <ButtonContainer>
              <Button type={"submit"}>
                {fetching ? <LoadingIcon /> : "Update Project Details"}
              </Button>
            </ButtonContainer>
          </form>
        )}
      />
    );
  }
}

export default EditProjectDetailsForm;
